<template>
    <div class="container-fluid">
        <div class="page-title" >
            <h4 v-if="!mobile">Outils</h4>
        </div>
        
        <b-overlay :show="SystemIsShown" rounded="sm" opacity="0.50 " variant="white striped">
        
        <div class="row">
            
            <div class="col-md-12">
                <div class="card">
                    <div class="card-block">
                        <div class="table-overflow">
                            
                            <b-form-input
                                v-model="filter"
                                type="search"
                                placeholder="Saisissez votre recherche"
                            ></b-form-input>
                            

<!-- * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * *  -->  
                                <div class="col-md-7 fixed-top m-auto mrg-top-70" v-if="error.alert!=null">

                                    <b-alert
                                        :show="alert.dismissCountDown"
                                        dismissible :variant="error.alert? 'danger' : 'success'"
                                        @dismissed="[alert.dismissCountDown=0,error.alert=null]"
                                        @dismiss-count-down="countDownChanged">
                                        <div class="text-center m-auto pl-4" :class="error.alert? 'text-danger' : 'text-dark'" > 
                                            <span v-if="!error.alert" class="lead"> Les paramètres ont été mis à jour avec succès. </span>
                                            <span v-else class="lead"> {{error.txt}} </span>
                                            <br><hr>
                                            <span>Cette alerte disparaîtra après {{alert.dismissCountDown}} secondes ... </span>
                                        </div>
                                    </b-alert>
                                </div>
<!-- * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * *  -->  

                            <b-table    :fields="fields"
                                        :items="items"
                                        :filter="filter"
                                        :no-sort-reset="true"
                                        @filtered="onFiltered"
                                        @row-dblclicked="open_updateSystem"
                                        class='BTable' sticky-header striped no-border-collapse>
                                <template #cell(name)="data">
                                    <span>
                                        {{data.item.system.name}}
                                    </span>
                                    <span v-if="data.item.system.plate!=null" v-bind:id="'affected_plate_'+data.item.system.id" @click="showPlateTooltip('tooltip_plate_'+data.item.system.id)">
                                        <i class="ti-comments"></i>
                                        <b-tooltip v-bind:target="'affected_plate_'+data.item.system.id" placement="auto" v-bind:triggers="mobile==true ? 'click' :'hover'" v-bind:ref="'tooltip_plate_'+data.item.system.id">
                                            Code plaque : K{{data.item.system.plate.code}}<br>
                                            Numéro de téléphone : <a :href="`tel:${data.item.system.plate.tel}`"> {{ data.item.system.plate.tel }}</a>
                                        </b-tooltip>
                                    </span>
                                </template>

                                <template #cell(code)="data">
                                    <span>
                                        {{data.item.system.code}}
                                    </span>
                                </template>
 
                                <template #cell(sensor)="data">
                                    <span v-if="!data.item.system.sensor">{{data.item.sensor}}</span>
                                    <span v-else v-bind:id="'affected_button_'+data.item.system.id">
                                        <button class="btn btn-sm btn-outline-light active fake_button" >{{data.item.sensor}}<br></button>
                                        <b-tooltip v-bind:target="'affected_button_'+data.item.system.id" triggers="hover" placement="bottom" v-bind:title="data.item.Outil_associe_depuis">
                                            {{data.item.Outil_associe_depuis}}
                                        </b-tooltip>
                                    </span>
                                </template>

                                <template #cell(responsable)="data">
                                    <span>
                                        {{data.item.responsable}}
                                    </span>
                                </template>

                                <template #cell(calibration)="data">
                                    <button class="btn btn-icon btn-rounded" v-bind:class="[(data.item.system.display_unit_id !=+1 ) ? 'btn-primary' : 'btn-flat']" @click="open_calibrate_system_modal(data.item.system)">
                                            <i class="ti-settings"></i>
                                    </button>
                                </template>

                                <template #cell(extraction)="data">
                                    <button class="btn btn-icon btn-rounded btn-info" @click="open_extraction_system(data.item.system)">
                                        <i class="ti-export"></i>
                                    </button>
                                </template>

                                <template #cell(agenda)="data">
                                    <button class="btn btn-rounded" @click="agenda_system_modal(data.item.system)" v-bind:class="[(data.item.system.in_use) ? 'btn-warning' : 'btn-primary']">
                                        <i class="ti-calendar"></i>
                                    </button>
                                </template>


                                <template #cell(nb_comment)="data">
                                    <button id="" class="btn btn-icon btn-icon btn-default btn-rounded lightBlueColor" @click="comments_system_modal_open(data.item.system)" :disabled='data.item.system.NbComments==0'>
                                        <i class="ti-comment-alt">
                                        </i>
                                        <span>
                                            {{data.item.nb_comment}}
                                        </span>
                                        
                                    </button>
                                </template>

                                <template #cell(last_pos)="data">
                                    <button class="btn btn-icon mrg-top-5" v-bind:class="[(data.item.system.geolocation_type=='None') ? 'lightBlueColor btn-default btn-rounded ' : 'btn-rounded lightBlueColor']" @click="map_system_modal_open(data.item.system)" :disabled='data.item.system.geolocation_type=="None"'>
                                                <i class="ti-map-alt"></i>
                                    </button>
                                </template>

                                <template #cell(positions)="data">
                                    <button class="btn btn-icon mrg-top-5" v-bind:class="[(data.item.system.geolocation_type=='None') ? 'lightBlueColor btn-default btn-rounded ' : 'btn-rounded lightBlueColor']" @click="map1_system_modal_open(data.item.system)" :disabled='data.item.system.geolocation_type=="None"'>
                                                <i class="ti-map-alt"></i>
                                    </button>
                                </template>

                                <template #cell(graph)="data">
                                   <button class="btn btn-icon mrg-top-5 btn-rounded lightBlueColor" @click="graph_system_modal_open(data.item.system)">
                                        <font-awesome-icon icon="fa-solid fa-chart-column"/>
                                    </button>
                                </template>

                            </b-table>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        </b-overlay>
<!-- ######################################################################################### -->
                
        <b-modal ref="updateSystem_popup" hide-footer centered no-close-on-backdrop hide-header-close v-bind:title="'Modifier l\'outil'" >
            
            <v-update-system
                :selected_system="selected_system"
                @update-system-done = "close_updateSystem"
                
            ></v-update-system>
        </b-modal>

        <b-modal ref="calibration_popup" hide-footer centered title="Parametrez votre outil" >
            <v-calibration 
                :system="selected_system"
                @calibration-done = "close_calibrate_system_modal">
                Custom
            </v-calibration>
        </b-modal>
        <b-modal ref="extraction_popup" hide-footer centered title="Extraction" size="xl">
            <!-- to change the b-modal size size="xl" or size="lg" or size="sm" -->
            <div  class="card border-0 align-items-center" v-for="struct in structure" v-bind:key="struct.id">
            <v-extraction 
                :system="selected_system"
                :start_date="struct.cloture_exercice"
                :subscriptionOK="true"
                @extraction-done = "close_extraction_system">
                Custom
            </v-extraction>
            </div>
        </b-modal>

        
        <b-modal ref="comments_popup" hide-footer centered :title="Commentaires" size="xl">
            <v-comments :system="selected_system">

            </v-comments>
        </b-modal>

        <b-modal ref="map_popup" hide-footer centered title="Dernière position de l'outil"  v-bind:size="(this.mobile ? '' : 'xl')">
            <v-map 
                :location_info="selected_system"
                @map-done = "close_map_system_modal"
            >
            </v-map>
        </b-modal>


        <b-modal ref="map1_popup" hide-footer centered title=" Positions de l'outil" >
            <v-map1 
                :location_info="selected_system"
                @map-done = "close_map1_system_modal"
            >
            </v-map1>
        </b-modal>
        
        <b-modal ref="graph_popup_system" hide-footer centered v-bind:title="'Graphes : '+selected_system.name + ' ('+selected_system.code+')'" size="xl">
            <!-- to change the b-modal size size="xl" or size="lg" or size="sm" -->
            <div  class="card border-0 align-items-center" v-for="struct in structure" v-bind:key="struct.id">
                <v-graph
                    :system="selected_system"
                    :subscriptionOK="true"
                    @graph-done = "close_graph_system_modal">
                    Custom
                </v-graph>
            </div>
        </b-modal>

    </div>
</template>

<script>
    import { mapGetters } from 'vuex';
    import Calibrate from "../Systems/Calibrate";
    import Extraction from "../../components/Extraction/Extraction.vue";
    import Sytem_comments from "../Systems/comments";
    import mMap from "../../components/Map/Map";
    import mMap1 from "../../components/Map/Map1";
    import UpdateSystem from "../../components/System/UpdateSystem.vue";
    import Graph from "../../components/Graph/Graph3.vue"
    

    export default {
        name: "Index",
        components:{
            'v-calibration': Calibrate,
            'v-extraction' : Extraction,
            'v-comments' : Sytem_comments,
            'v-map': mMap,
            'v-map1': mMap1,
            'v-update-system': UpdateSystem,
            'v-graph' : Graph
            //'v-system-alert': systemAlert,
            
        },
        data () {
            return {
                error : {
                    alert : null,
                    txt : "",
                },
                action : "index",
                selected_system: {
                    name: "",
                    code: ""
                },
                window: {
                    width: 0,
                    height: 0
                },
                mobile: false,
                tdClass : "text-center align-middle",
                thClass : "text-center",
                
                rows: 1,
                filter: null,
                group_selected: 0,
                
            }
        },
        computed: {
            ...mapGetters({ 
                structure : 'structure/structure',
                systems: 'systems/systems',
            }), 

            fields(){       //TODO adapt fields
                var fields=[];
                if(this.mobile){
                    fields=[
                        {key :'name', label : 'Nom de l\'outil', sortable: true, thClass: this.thClass, tdClass:  this.tdClass},
                        {key :'agenda', label : 'Agenda', sortKey:'in_use', sortable: true, thClass: this.thClass, tdClass: this.tdClass},
                        {key :'last_pos', label : 'Dernière Position', sortKey:'Date_on_last_pos', sortable: true, thClass: this.thClass, tdClass: this.tdClass},
                        {key :'code', label : 'Code l\'outil', sortable: true, thClass: this.thClass, tdClass: this.tdClass},
                        {key :'sensor', label : 'Compteur associé', sortable: true, thClass: this.thClass, tdClass: this.tdClass},
                        {key :'responsable', label : 'Responsable', sortable: true, thClass: this.thClass, tdClass: this.tdClass},
                        {key :'calibration', label :'Calibration', sortKey:'calibrate', sortable: true, thClass: this.thClass, tdClass:this.tdClass},
                        {key :'extraction', label : 'Extraction', sortable: true, thClass: this.thClass, tdClass: this.tdClass},
                        {key :'nb_comment', label : 'Commentaires', sortable: true, thClass: this.thClass, tdClass: this.tdClass},
                  //      {key :'positions', label : 'positions_gps', sortable: true, thClass: this.thClass, tdClass: this.tdClass},
                    ];
                }
                else {
                    fields=[
                        {key :'name', label : 'Nom de l\'outil', sortable: true, thClass: this.thClass, tdClass:  this.tdClass},
                        {key :'code', label : 'Code l\'outil', sortable: true, thClass: this.thClass, tdClass: this.tdClass},
                        {key :'sensor', label : 'Compteur associé', sortable: true, thClass: this.thClass, tdClass: this.tdClass},
                        {key :'responsable', label : 'Responsable', sortable: true, thClass: this.thClass, tdClass: this.tdClass},
                        {key :'calibration', label :'Calibration', sortKey:'calibrate', sortable: true, thClass: this.thClass, tdClass:this.tdClass},
                        {key :'last_pos', label : 'Dernière Position', sortKey:'Date_on_last_pos', sortable: true, thClass: this.thClass, tdClass: this.tdClass},
                        {key :'agenda', label : 'Agenda', sortKey:'in_use', sortable: true, thClass: this.thClass, tdClass: this.tdClass},
                        {key :'extraction', label : 'Extraction', sortable: true, thClass: this.thClass, tdClass: this.tdClass},
                        {key :'nb_comment', label : 'Commentaires', sortable: true, thClass: this.thClass, tdClass: this.tdClass},
                        {key :'graph', label : 'Courbes', sortable: true, thClass: this.thClass, tdClass: this.tdClass},
                   //     {key :'positions', label : 'positions_gps', sortable: true, thClass: this.thClass, tdClass: this.tdClass},
                    ];
                }
                return fields;
            },
            items(){        //TODO adapt items
                var items=[];
                        
                var responsable="" ;
                var sensor_lbl="";
                var Outil_associe_depuis="";
                var nb_comment = " ";
                for (var system of this.systems){
                     
                    if(!system.sensor)   {
                        sensor_lbl=' Pas de compteur ';   //Les espaces sont mis pour que le tri fonctionne
                        Outil_associe_depuis='';
                    }
                    else {
                        sensor_lbl = system.sensor.name;
                        Outil_associe_depuis="depuis le "+this.getDate(system.sensor.pivot.created_at);
                    }

                    system.latitude = parseFloat(system.latitude);
                    system.longitude = parseFloat(system.longitude);
                    
                    if(system.NbComments>0){
                        nb_comment = " " + system.NbComments;
                    }
                    //verifier si le materiel est reservé ou pas
                    //system.reserved= false;
                    //system.reserved= this.reservationCourante(system);

                    //Mise en forme du nom du responsable en interne pour que le tri fonctionne
                    if(system.responsible.title == null){system.responsible.title = "";}
                    if(system.responsible.firstname == null){system.responsible.firstname = "";}
                    if(system.responsible.lastname == null){system.responsible.lastname = "";}
                    
                    if((system.responsible != null) && (system.responsible_id != 1)){
                        responsable = system.responsible.title+" "+system.responsible.firstname+" "+system.responsible.lastname;
                    }
                    else{
                        responsable = " Non défini ";
                    }

                    items.push(
                    {
                        system : system,
                        name : system.name,
                        sensor :sensor_lbl,
                        responsable : responsable,
                        nb_comment : nb_comment,
                        Outil_associe_depuis : Outil_associe_depuis,
                        Calibration_compteur : system.mirror_system,
                        Date_on_last_pos : system.Date_on_last_pos,
                        in_use : system.in_use?"vrai":"faux",
                        calibrate : system.display_unit_id,
                        Positions_list:Outil_associe_depuis,
                        code : system.code,
                    });
                    //RAZ des variables avant le prochain push
                    responsable="" ;
                    sensor_lbl="";
                    Outil_associe_depuis="";
                    nb_comment = " ";
                }
                items.sort((a, b) => a.name.localeCompare(b.name)); // Tri par nom de l'outil
                return items;
            },
            limitedDate(){
                let date = new Date();
                let nowDate = Date.parse(date);
                //console.log(nowDate);
                let limitedDate = nowDate - (24*3600*10000);
                return limitedDate;
            },
            SystemIsShown (){
                return this.systems.length==0? true : false ;
            },
            Commentaires(){
                return "Commentaires : "+this.selected_system.name+" ("+this.selected_system.code+")";
            }
        },
        created() {
            window.addEventListener('resize', this.handleResize);
            this.handleResize();
        },
        mounted() {
            this.$store.dispatch('structure/getStructure');
            this.$store.dispatch('systems/getSystems');
            this.rows = this.systems.length;
        },
        destroyed() {
            window.removeEventListener('resize', this.handleResize);
        },

        methods: {
            handleResize() {
                this.window.width = window.innerWidth;
                this.window.height = window.innerHeight;
                this.mobile=(this.window.width<1080)? true : false ;
            },

            formatDate: function(date){
                var d = new Date(date),
                    month = '' + (d.getMonth() + 1),
                    day = '' + d.getDate(),
                    year = '' + d.getFullYear(),
                    hour = '' + d.getHours(),
                    minute ='' + d.getMinutes();
                //console.log("Date_to_format "+d)
                if (month.length < 2) 
                    month = '0' + month;
                if (day.length < 2) 
                    day = '0' + day;
                if (hour.length < 2) 
                    hour = '0' + hour;
                if (minute.length < 2) 
                    minute = '0' + minute;

                return [year, month, day].join('-') + " à " + [hour, minute].join(':');
            },

            timeSinceDate: function(lastUp){

                let date= new Date();
                
                let nowDate = Date.parse(date);
                var lastDate = Date.parse(lastUp) - date.getTimezoneOffset()*60*1000;//On part déjà d'une date UTC auquel on réapplique les timezone offset
                
                //console.log("NowDate: "+ date + "\t" + nowDate);
               //console.log("LastUp: "+ lastUp + "\t" + lastDate);
                var diff = nowDate - lastDate;
                //console.log(diff);
                if(diff > 0){
                    var diffDate = new Date(diff);
                    diffDate = new Date(diff+diffDate.getTimezoneOffset()*60*1000); //Pour corriger le passage d'utc à heure locale
                    var lastUpdate = "";
                    //console.log(diffDate)

                    if((diffDate.getFullYear() > 1970) || (diffDate.getMonth()>0) || (diffDate.getDate()>1)){

                        if(diffDate.getFullYear() > 1970){
                            lastUpdate = lastUpdate + (diffDate.getFullYear()-1970) + " an(s) ";
                        }
                        if(diffDate.getMonth()>0){
                            lastUpdate = lastUpdate + diffDate.getMonth() + " mois ";
                        }
                        if(diffDate.getDate()>0){
                            if(diffDate.getDate() == 1){
                                lastUpdate = lastUpdate + diffDate.getDate() + " jour ";
                            }
                            else{
                                lastUpdate = lastUpdate + diffDate.getDate() + " jours ";
                            }
                        }
                        return lastUpdate + " (" + this.formatDate(lastDate).substring(0,10) +")"
                    }
                    else if((diffDate.getHours()>0) || (diffDate.getMinutes()>0)){
                        if(diffDate.getHours()>0){
                            if(diffDate.getHours() == 1){
                                lastUpdate = lastUpdate + diffDate.getHours() + " heure ";
                            }
                            else{
                                lastUpdate = lastUpdate + diffDate.getHours() + " heures ";
                            }
                        }
                        if(diffDate.getMinutes()>0){
                            if(diffDate.getMinutes() == 1){
                                lastUpdate = lastUpdate + diffDate.getMinutes() + " minute";
                            }
                            else{
                                lastUpdate = lastUpdate + diffDate.getMinutes() + " minutes";
                            }
                        }
                        return lastUpdate + " (" + this.formatDate(lastDate) +")"
                    }
                }
                else if(lastUp == null){
                    return "Information non disponible"
                }

            },
            seconds_To_Hms(timestamp){

                var hours = Math.floor(timestamp / 3600 );

                var minutes = Math.floor(timestamp / 60) - (hours * 60);

                //var seconds = timestamp % 60;
                
                var formatted=""
                /* // pour afficher jour H:m:s au cas ou on passe 24h 
                if(hours>=24){
                    var days=Math.floor(hours / 24);
                    formatted +=days.toString().padStart(2, '0')+" jour(s) ";
                    hours -= days * 24 ;
                }
                */
               //affichage de type H:m:s
                formatted += hours.toString().padStart(2, '0') + ':' + minutes.toString().padStart(2, '0')+" h";
                return formatted ;

            },
            getDate(date){
                var d = new Date(date);
                var day = d.getDate(); 
                var m = d.getMonth()+1;
                var y = d.getFullYear();
                var fulldate=y+"-";
                if(m<10) fulldate+="0";
                fulldate+=m+"-";
                if(day<10) fulldate+="0";
                fulldate+=day;
                return fulldate;
            },

            open_calibrate_system_modal(system) {
                //Passer le système selectionné à l'enfant
                this.selected_system = system;
                this.$refs.calibration_popup.show()
            },
            close_calibrate_system_modal() {
                this.$refs.calibration_popup.hide();
                this.$store.dispatch('systems/getSystems').then(() => {
                    this.sortDirection = '';
                    this.sortBy ='';
                });
            },
            
            agenda_system_modal(system){
                this.$router.push({ path: `/calendar/${system.id}` });
            },

            open_extraction_system(system){
                //Passer le système selectionné à l'enfant
                this.selected_system = system;
                this.$refs.extraction_popup.show();
            },
            close_extraction_system() {
                this.$refs.extraction_popup.hide();
                this.$store.dispatch('systems/getSystems').then(() => {
                    this.sortDirection = '';
                    this.sortBy ='';
                });
            },
            open_updateSystem(item){
                this.selected_system=item.system;
                this.$refs.updateSystem_popup.show();
            },
            close_updateSystem() {
               this.$refs.updateSystem_popup.hide();
                setTimeout(() => {
                    this.$forceUpdate();
                }, 500);
                //this.selected_system = null;
                //this.selected_system= resp.resp.data;
            },
            seuilConfig_open() {
               // this.selected_system = this.selected_system; 
                this.$refs.seuilConfig_popup.show()
            },
            close_seuilConfig() {
                this.$refs.seuilConfig_popup.hide();
            },

            map_system_modal_open(system) {
                this.selected_system = system;
                //Passer le système selectionné à l'enfant
                this.$refs.map_popup.show()
            },
            close_map_system_modal() {
                this.$refs.map_popup.hide();
            },

            map1_system_modal_open(system) {
                this.selected_system = system;
                //Passer le système selectionné à l'enfant
                this.$refs.map1_popup.show()
            },
            close_map1_system_modal() {
                this.$refs.map1_popup.hide();
            },

            comments_system_modal_open(system){
                this.selected_system = system;
                this.$refs.comments_popup.show();
            },
            comments_system_modal_close(){
                //this.selected_system=null;
                this.$refs.comments_popup.hide();
            },

            graph_system_modal_open(system){
                this.$store.dispatch('systems/getSystems').then(() => {
                    this.sortDirection = '';
                    this.sortBy ='';
                });
                this.selected_system = system;
                //Passer le système selectionné à l'enfant
                this.$refs.graph_popup_system.show()
            },
            close_graph_system_modal() {
                this.$refs.graph_popup_system.hide();
            },

            onFiltered(filteredItems) {
                this.rows = filteredItems.length
            },
            showPlateTooltip(tooltipRef){
                if(this.mobile){
                    var $tooltip = tooltipRef;
                    this.$refs[tooltipRef].$emit('open');
                    setTimeout(function ()  { 
                        this.$refs[$tooltip].$emit('close');
                    }.bind(this,$tooltip),1000);
                }
            }
        }

    }
</script>

<style>

.asc:after{
    content: "\25B2"
}

.desc:after{
    content: "\25BC"
}
.BTable{
    max-height: 700px;
}
.lightBlueColor:enabled{
  background-color: rgba(200, 217, 255, 0.68);
}

.fake_button{

    margin-top:8px;
    pointer-events: none;
}

</style>